import React, { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import moment from 'moment-timezone';
import { useSelector } from 'react-redux';
import { IntlDayPicker } from '@showclix-shared/IntlDayPicker';

export const DateQuestion = ({
  onFocus: onFocusProp,
  onBlur: onBlurProp,
  onAnswerUpdate,
  textQuestionValue,
  inputId,
  errorId,
  hasError,
  ...rest
}) => {
  const locale = useSelector(state => state.intl.locale);

  const dayPickerRef = useRef(null);
  const inputRef = useRef(null);
  const [isPickerVisible, setIsPickerVisible] = useState(false);

  const inputWrapClassName = classNames('input', 'input--inset', 'input--date', {
    ['input--error']: hasError
  });

  const selectedDay = textQuestionValue ? new Date(textQuestionValue) : undefined;

  const formatedDateString = textQuestionValue ? new Date(textQuestionValue).toLocaleDateString(locale) : '';

  const onBlur = () => {
    // need delay, since onBlur triggers question validatio
    // so it need a small gap before answer update in the store
    setTimeout(() => {
      onBlurProp?.();
    }, 100);
  };

  const showDayPicker = () => {
    setIsPickerVisible(true);
    document.addEventListener('mousedown', onClickOutside);
  };

  const hideDayPicker = () => {
    setIsPickerVisible(false);
    onBlur();
    document.removeEventListener('mousedown', onClickOutside);
  };

  const onFocus = e => {
    onFocusProp?.(e);
    showDayPicker();
  };

  const onDaySelect = e => {
    const value = `${moment(e).format('MM/DD/YYYY')}`;
    onAnswerUpdate(value);
    hideDayPicker();
  };

  const onClickOutside = e => {
    if (!dayPickerRef.current) return;

    if (!dayPickerRef.current.contains(e.target)) {
      hideDayPicker();
    }
  };

  const onDayPickerWrapBlur = e => {
    if (!dayPickerRef.current) return;

    if (!dayPickerRef.current.contains(e.relatedTarget)) {
      hideDayPicker();
    }
  }

  const onKeyDown = e => {
    if (e.key === 'Escape') {
      inputRef.current?.focus();
      hideDayPicker();
      e.stopPropagation();
    }
  };

  const onInputKeyDown = e => {
    if (e.key === 'Enter') {
      showDayPicker();
      e.preventDefault();
    }
  }

  useEffect(() => {
    document.addEventListener('keydown', onKeyDown);

    return () => {
      document.removeEventListener('click', onClickOutside);
      document.removeEventListener('keydown', onKeyDown);
    };
  }, []);

  return (
    <div className={inputWrapClassName}>
      <input
        id={inputId}
        ref={inputRef}
        className="input__control"
        type="text"
        name="date_question"
        readOnly
        placeholder="Your answer here"
        onFocus={onFocus}
        onKeyDown={onInputKeyDown}
        value={formatedDateString}
        aria-invalid={hasError}
        aria-describedby={hasError ? errorId : undefined}
        {...rest}
      />
      {isPickerVisible && (
        <div ref={dayPickerRef} className="input--date-picker-wrapper" onBlur={onDayPickerWrapBlur}>
          <div className="ReactDayPicker ReactDayPicker--date-question">
            <IntlDayPicker
              rootClassName="checkout-rdp-root"
              onSelect={onDaySelect}
              selected={selectedDay}
            />
          </div>
        </div>
      )}
    </div>
  );
};
